import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import UICardGrid from 'UIComponents/card/UICardGrid';
import { useResponsiveProps } from 'ecosystem-marketplace-core/hooks/useResponsiveProps';
import StorefrontSection from '../StorefrontSection';

const StorefrontResultsSection = (_ref) => {
  let {
    results,
    ResultComponent,
    trackInteraction,
    trackPageview
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, ["results", "ResultComponent", "trackInteraction", "trackPageview"]);

  const responsiveProps = useResponsiveProps({
    columns: {
      xs: 1,
      sm: 2,
      md: 3
    }
  });
  return /*#__PURE__*/_jsx(StorefrontSection, Object.assign({}, rest, {
    children: /*#__PURE__*/_jsx(UICardGrid, Object.assign({}, responsiveProps, {
      children: results.map((result, index) => /*#__PURE__*/_jsx(ResultComponent, {
        index: index,
        onClick: () => {
          trackInteraction('click result item', {
            value: result.slug,
            itemIndex: index,
            totalResults: results.length
          });
        },
        result: result,
        resultsLength: results.length,
        trackInteraction: trackInteraction,
        trackPageview: trackPageview
      }, `result-${index}`))
    }))
  }));
};

export default StorefrontResultsSection;